import { SaleListRow } from '@/hooks/publicSearch/sale-catalogue/helpers';
import { FieldOption, GetSalesRow, SaleType } from '../constants';
import { getGridOperatorsByField } from '../search/helpers';

// Map sale type codes to display names (listing L and report R)
const saleTypeDisplayMap: Record<string, string> = {
  [SaleType.CurrentSaleListing]: 'Sales',
  [SaleType.CurrentPrivateTreatySaleListing]: 'Private Treaty',
  [SaleType.SemenListing]: 'Semen',
  [SaleType.EmbryoListing]: 'Embryo',
  [SaleType.CompletedSaleListing]: 'Sales',
  [SaleType.CompletedPrivateTreatySaleListing]: 'Private Treaty',
  [SaleType.CompletedSemenListing]: 'Semen',
  [SaleType.CompletedEmbryoListing]: 'Embryo',
};

export const saleCatalogueColumns = [
  {
    field: FieldOption.saleDate.value,
    filterOperators: getGridOperatorsByField(FieldOption.saleDate.value),
    headerName: FieldOption.saleDate.label,
    flex: 1,
    minWidth: 80,
  },
  {
    field: FieldOption.saleType.value,
    filterOperators: getGridOperatorsByField(FieldOption.saleType.value),
    headerName: 'Sale Type',
    flex: 1,
    minWidth: 120,
    renderCell: ({ row }: { row: GetSalesRow }) => {
      return saleTypeDisplayMap[row.SALE_TYPE] || row.SALE_TYPE;
    },
  },
  {
    field: FieldOption.saleName.value,
    filterOperators: getGridOperatorsByField(FieldOption.saleName.value),
    headerClassName: 'pl',
    headerName: FieldOption.saleName.label,
    flex: 3,
    minWidth: 80,
    renderCell: ({ row }: { row: GetSalesRow }) => <SaleListRow row={row} />,
  },
  {
    field: FieldOption.lotCount.value,
    filterable: false,
    headerName: FieldOption.lotCount.label,
    flex: 1,
    minWidth: 80,
  },
];
